(function(scope){
 'use strict';
 const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
 const smooth=t=>{t=clamp(t);return t*t*(3-2*t);};
 const overlap=(a,b,g=4)=>a.left<b.right+g&&a.right>b.left-g&&a.top<b.bottom+g&&a.bottom>b.top-g;
 function route(view,size,obstacles,origin,clip){
  const left=view.left||0,top=view.top||0,right=left+view.width,bottom=top+view.height;
  const ys=[bottom-size-12,top+12,top+view.height*.66,top+view.height*.4];
  for(const y of ys){
   const corridor={left,top:y-5,right,bottom:y+size+5};
   if(corridor.top<top||corridor.bottom>bottom||obstacles.some(r=>overlap(corridor,r,2)))continue;
   return {x:left-size-2,y,endX:right+size*.1+2,endY:y,full:true,direction:1};
  }
  if(!origin||origin.edge)return null;
  const destinations=clip.id==='rocket'?[[right+size,-size+top],[left-size,-size+top]]:[[right+2,origin.y],[left-size-2,origin.y]];
  for(const [endX,endY]of destinations){
   const r={left:Math.min(origin.x,endX),right:Math.max(origin.x,endX)+size,top:Math.min(origin.y,endY),bottom:Math.max(origin.y,endY)+size};
   if(!obstacles.some(o=>overlap(r,o,4)))return{x:origin.x,y:origin.y,endX,endY,full:false,direction:endX>origin.x?1:-1};
  }
  return null;
 }
 /* Die Dauer wird auf ganze Schleifendurchläufe gerundet. Ohne das bricht
    eine gestreckte Reise-Animation mitten im Zyklus in die Endphase um und
    springt sichtbar mehrere Einzelbilder weit. */
 function timing(clip,path,size){
  const distance=path?Math.hypot(path.endX-path.x,path.endY-path.y):0;
  const intro=clip.enterFrames/clip.fps*1000,outro=(clip.frames-clip.exitStart)/clip.fps*1000;
  const loopMs=clip.loopFrames/clip.fps*1000;
  let duration=path?Math.max(clip.duration*1000,distance/(size*clip.speed)*1000+900):clip.duration*1000;
  if(loopMs>0){
   const cycles=Math.max(1,Math.round((duration-intro-outro)/loopMs));
   duration=intro+cycles*loopMs+outro;
  }
  return {duration,distance,intro,outro,loopMs,cycles:loopMs>0?Math.round((duration-intro-outro)/loopMs):0};
 }
 function sample(clip,elapsed,{path=null,size=72,origin={x:0,y:0},edge=null}={}){
  const time=timing(clip,path,size),duration=time.duration,t=clamp(elapsed/duration),intro=time.intro,outro=time.outro;
  const enter=smooth(elapsed/intro),leave=smooth((elapsed-duration+outro)/outro),phase=elapsed<intro?'enter':elapsed>=duration-outro?'exit':'loop';
  const loopSpan=Math.max(1,duration-intro-outro);
  /* Der letzte Schleifenindex wird gedeckelt. Ohne den Deckel kippt der
     Rundungszuschlag genau an der Nahtstelle in den nächsten Zyklus und die
     Figur springt an den Schleifenanfang zurück, bevor die Endphase greift. */
  const loopTotal=Math.max(1,Math.round(loopSpan*clip.fps/1000));
  const loopIndex=Math.min(loopTotal-1,Math.max(0,Math.floor((elapsed-intro)*clip.fps/1000+1e-7)));
  let frame=phase==='enter'?Math.floor(elapsed*clip.fps/1000+1e-7):phase==='exit'?clip.exitStart+Math.floor((elapsed-duration+outro)*clip.fps/1000+1e-7):clip.loopStart+loopIndex%clip.loopFrames;
  let x=origin.x,y=origin.y,angle=0,distance=0;
  if(path){
   /* Gehen hat konstantes Tempo. Mit smooth(t) waere die Figur am Anfang und
      Ende langsam, waehrend die Beine gleich schnell treten — sichtbarer
      Fussschlupf. Fuer „wander" also linear. */
   const p=clip.id==='rocket'?Math.pow(t,1.65):clip.id==='zoom'?t*t:clip.id==='wander'?t:smooth(t);
   x=path.x+(path.endX-path.x)*p;y=path.y+(path.endY-path.y)*p;distance=time.distance*p;
   /* „wander" hat in An- und Abspann zwölf identische Standbilder. Über die
      ganze Strecke durchzulaufen hiesse dort zwei Sekunden Gleiten ohne
      Beinbewegung — deshalb laeuft hier durchgehend der Schrittzyklus, an die
      zurueckgelegte Strecke gekoppelt. */
   if(clip.id==='wander'){
    const steps=Math.max(1,Math.round(time.distance/(size*clip.stride))),total=steps*clip.loopFrames;
    frame=clip.loopStart+Math.min(total-1,Math.floor(p*total+1e-7))%clip.loopFrames;
   }
   if(clip.id==='rocket')angle=-.08*enter*path.direction;
  }
  let cut=null,hands=0;
  if(edge!==null&&['peek','hide'].includes(clip.id)){
   const reveal=clip.id==='hide'?1-leave:enter*(1-leave);
   y=edge-size*.64+size*.72*(1-reveal);
   cut=clamp((edge-y)/size);hands=clip.id==='hide'?1-smooth((t-.6)/.25):smooth(t/.16)*(1-smooth((t-.78)/.14));
  }
  if(['sit','perch'].includes(clip.id)&&edge!==null){y=origin.y-Math.sin(Math.PI*enter)*size*.13*(phase==='enter'?1:0);cut=clamp((edge+size*.065-y)/size);}
  return {frame:clamp(frame,0,clip.frames-1),phase,done:elapsed>=duration,duration,t,x,y,angle,distance,cut,hands,direction:path?.direction||1};
 }
 function star(ctx,x,y,r,angle=0){
  ctx.save();ctx.translate(x,y);ctx.rotate(angle);ctx.beginPath();
  for(let i=0;i<8;i++){const a=i*Math.PI/4-Math.PI/2,d=i%2?r*.25:r;i?ctx.lineTo(Math.cos(a)*d,Math.sin(a)*d):ctx.moveTo(Math.cos(a)*d,Math.sin(a)*d);}ctx.closePath();ctx.fill();ctx.restore();
 }
 class Particles{
  constructor(){this.items=[];this.last=-Infinity;this.burst=false;}
  clear(){this.items.length=0;this.last=-Infinity;this.burst=false;}
  draw(ctx,now,sample,clip,size,enabled=true){
   if(!enabled){this.clear();return;}
   const cap=size<=56?12:26,moving=['trail','rocket','wake','steps'].includes(clip.effect),burst=clip.effect==='burst'&&sample.t>.36&&sample.t<.65&&!this.burst;
   const interval=clip.effect==='steps'?260:moving?65:320;
   if((now-this.last>interval&&sample.t>.08&&sample.t<.9)||burst){
    this.last=now;if(burst)this.burst=true;
    const count=burst?9:1;
    for(let i=0;i<count;i++){
     const n=this.items.length+i+Math.floor(now/97),a=(n*2.399963)%(Math.PI*2);
     const back=sample.direction>0?.25:.75;
     this.items.push({x:sample.x+size*(moving?back:.52),y:sample.y+size*(clip.effect==='steps'?.94:clip.effect==='wake'?.9:clip.effect==='rocket'?.78:.28),born:now,life:burst?850:moving?650:1050,vx:Math.cos(a)*(burst?size*.065:size*.018),vy:burst?Math.sin(a)*size*.06:-size*.035,r:Math.max(1.3,size*(burst?.028:.018)),a,c:clip.effect==='rocket'?'#ebd2ff':n%3===0?'#f4e4ce':'#a78aef'});
    }
   }
   this.items=this.items.filter(p=>now-p.born<p.life).slice(-cap);
   for(const p of this.items){const t=(now-p.born)/p.life;ctx.globalAlpha=(1-t)*.68;ctx.fillStyle=p.c;const x=p.x+p.vx*t*8,y=p.y+p.vy*t*6;
    if(clip.effect==='wake'||clip.effect==='steps'){ctx.beginPath();ctx.ellipse(x,y,p.r*(1+t*2),p.r*.4,0,0,Math.PI*2);ctx.fill();}else star(ctx,x,y,p.r*(1-t*.6),p.a+t*.4);
   }ctx.globalAlpha=1;
  }
 }
 const api={clamp,smooth,overlap,route,timing,sample,star,Particles};
 if(typeof module!=='undefined'&&module.exports)module.exports=api;
 else scope.MoonlingMotion=api;
})(typeof window==='undefined'?{}:window);
